import React from 'react';
import { shape, string } from 'prop-types';
import { Query } from 'react-apollo';
import _ from 'lodash';
import Layout from 'components/layout';
import withApplicationConfig from 'containers/withApplicationConfig';
import ProviderProductPage, {
  staticTextKeys as providerProductPageStaticTextKeys,
} from 'pages/Verticals/ProviderProductPage/ProviderProductPage';
import Queries from 'queries';
import {
  getAuthQueryVariables, getStaticText, getImages,
} from 'helpers/Utils';
import { LoadingIndicator } from 'components/common';

const ProviderProductPageQuery = ({
  match: { params }, localisation, language, contentstackKeys,
}) => {
  const { vertical: list, alias } = params;
  return (
    <Query
      query={Queries.GetProvider}
      variables={{
        language: localisation[language],
        list: list?.toLowerCase(),
        alias: alias?.toLowerCase(),
        ...getAuthQueryVariables({
          contentstackKeys,
          initailStaticTextKeys: providerProductPageStaticTextKeys,
        }),
      }}
    >
      {({ data, refetch, loading }) => {
        if (!data || loading) return <LoadingIndicator />;
        const providers = _.get(data, 'providerResultsPage.products', []);

        return (
          <Layout
            {...data.pageConfig}
            componentConfig={data?.componentConfig}
            seoMetadata={data.seoMetadata}
            customerProfile={data?.customerProfile}
            staticText={getStaticText(data)}
            images={getImages(data)}
            refetch={refetch}
          >
            <ProviderProductPage
              {...data.provider}
              {...data.pageConfig}
              providers={providers}
              seoTable={data?.seoMetadata?.seoTable}
            />
          </Layout>
        );
      }}
    </Query>
  );
};

ProviderProductPageQuery.propTypes = {
  match: shape({}),
  localisation: shape({}),
  language: string.isRequired,
  contentstackKeys: shape({}).isRequired,
};

ProviderProductPageQuery.defaultProps = {
  match: {},
  localisation: {},
};

export default withApplicationConfig(ProviderProductPageQuery, ['languages', 'contentstackKeys']);
